import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { getStartOfWeek } from './getStartOfWeek';

// Extend dayjs with localizedFormat plugin
dayjs.extend(localizedFormat);

export function getWeekdaysNames(locale, firstDayOfWeek = 'monday', format = 'dd') {
  try {
    const names = [];
    const startDate = getStartOfWeek(new Date(), firstDayOfWeek);

    for (let i = 0; i < 7; i += 1) {
      const currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + i);

      // Create dayjs instance and apply locale safely
      const dayjsInstance = dayjs(currentDate);
      const localizedInstance = locale ? dayjsInstance.locale(locale) : dayjsInstance;

      names.push(localizedInstance.format(format));
    }

    return names;
  } catch (error) {
    console.warn('Error formatting weekday names with locale, falling back to default:', error);

    // Fallback without locale
    const names = [];
    const startDate = getStartOfWeek(new Date(), firstDayOfWeek);

    for (let i = 0; i < 7; i += 1) {
      const currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + i);
      names.push(dayjs(currentDate).format(format));
    }

    return names;
  }
}